import http from './http'

export function setPendingOrder(order, accessToken) {
	return http({
		data: order,
		method: 'POST',
		url: `/rest/trades/pendings/orders?access_token=${accessToken}`
	})
}
export function setUpdatePendingOrder(order, accessToken) {
	return http({
		data: order,
		method: 'PUT',
		url: `/rest/trade/pending?access_token=${accessToken}`
	})
}

export function setOpenTrade(trade, accessToken) {
	return http({
		data: trade,
		method: 'POST',
		url: `/rest/trades?access_token=${accessToken}`
	})
}
export function setUpdateOpenTrade(data, accessToken, tradeId) {
	return http({
		data: data,
		method: 'PUT',
		url: `/rest/trades/${tradeId}/update/trade?access_token=${accessToken}`
	})
}
export function setClosePending(data, accessToken) {
	return http({
		data: data,
		method: 'POST',
		url: `/rest/trades/closes/pendings?access_token=${accessToken}`
	})
}
export function setCancelOpen(tradeId, accessToken) {
	return http({
		method: 'POST',
		url: `/rest/trades/${tradeId}/cancels/trades?access_token=${accessToken}`
	})
}
